import { useContext } from 'react';
import Context from './Context';
export { default } from './Provider';
export { default as withLiff } from './with';

export function useLiff() {
    return useContext(Context);
}
